/* Torque GT UX fixes - from Clarity session analysis (Sep-Oct 2026)
   C3: keep customers on /cart after logging in
   H3: tap-to-open image lightbox for the product gallery on phones/tablets
   Fitment message: vehicle name in regular weight
   Mobile: tap the star rating to jump to the reviews */
(function () {
  'use strict';

  /* ---------- C3: login links return to the cart ---------- */
  var AUTH_SELECTOR = 'a[href*="customer_authentication"]';

  function safeDecode(value) {
    try { return decodeURIComponent(value); } catch (e) { return value; }
  }

  // Works out where a login link should send the customer afterwards.
  // Honours an existing return_url / return_to (the Love Loyalty app appends one, but
  // with a second "?" that breaks it), otherwise uses /cart when on the cart page.
  function returnTarget(href) {
    var match = href.match(/[?&]return_(?:url|to)=([^&#]*)/i);
    var target = match ? safeDecode(match[1]) : '';
    if (!target && location.pathname.replace(/\/$/, '') === '/cart') target = '/cart';
    // Shopify only accepts relative paths for return_to.
    if (target.charAt(0) !== '/' || target.indexOf('//') === 0) return '';
    return target;
  }

  function fixLoginLink(link) {
    var href = link.getAttribute('href') || '';
    if (!/\/customer_authentication\/(redirect|login)/i.test(href)) return;

    var target = returnTarget(href);
    if (!target) return;

    var current;
    try { current = new URL(href, location.origin); } catch (e) { return; }

    var fixed = new URL('/customer_authentication/login', location.origin);
    ['locale', 'region_country'].forEach(function (key) {
      var value = current.searchParams.get(key);
      if (value) fixed.searchParams.set(key, value.split('?')[0]);
    });
    fixed.searchParams.set('return_to', target);

    link.setAttribute('href', fixed.pathname + fixed.search);
  }

  // Capture phase so the href is corrected just before navigation, which also covers
  // links that apps inject after page load (e.g. the loyalty widget in the cart).
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest && evt.target.closest(AUTH_SELECTOR);
    if (link) fixLoginLink(link);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(AUTH_SELECTOR).forEach(fixLoginLink);
  });

  /* ---------- H3: product gallery lightbox (touch devices) ---------- */
  // The theme only offers hover-zoom on desktop; on phones the zoom link is switched off and
  // tapping a gallery image does nothing. This opens the full-size image in a swipeable viewer.
  var touchMq = window.matchMedia ? window.matchMedia('(max-width: 767px), (pointer: coarse)') : null;
  var lb = null;

  function galleryImages(gallery) {
    var list = [];
    gallery.querySelectorAll('.media-viewer__item').forEach(function (item) {
      if (item.querySelector('deferred-media, product-model')) return; // videos / 3D stay as they are
      var img = item.querySelector('.product-image');
      if (!img) return;
      var link = item.querySelector('a.js-zoom-link');
      var src = (link && link.getAttribute('href')) || img.currentSrc || img.src;
      if (!src || /^data:/.test(src)) return;
      list.push({ item: item, src: src, alt: img.getAttribute('alt') || '' });
    });
    return list;
  }

  function closeLightbox() {
    if (!lb) return;
    document.removeEventListener('keydown', lb.onKey);
    document.body.style.overflow = lb.prevOverflow;
    lb.root.remove();
    var opener = lb.opener;
    lb = null;
    if (opener && opener.focus) opener.focus();
  }

  function showSlide(i) {
    lb.index = (i + lb.list.length) % lb.list.length;
    var entry = lb.list[lb.index];
    lb.img.src = entry.src;
    lb.img.alt = entry.alt;
    lb.count.textContent = (lb.index + 1) + ' / ' + lb.list.length;
  }

  function openLightbox(gallery, clickedItem) {
    var list = galleryImages(gallery);
    if (!list.length) return;
    var start = 0;
    list.forEach(function (entry, i) { if (entry.item === clickedItem) start = i; });

    var root = document.createElement('div');
    root.className = 'torque-lightbox';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product images');
    root.innerHTML =
      '<button type="button" class="torque-lightbox__close" aria-label="Close">&times;</button>' +
      '<div class="torque-lightbox__count" aria-live="polite"></div>' +
      '<button type="button" class="torque-lightbox__nav torque-lightbox__nav--prev" aria-label="Previous image">&#8249;</button>' +
      '<img class="torque-lightbox__img" alt="">' +
      '<button type="button" class="torque-lightbox__nav torque-lightbox__nav--next" aria-label="Next image">&#8250;</button>';
    document.body.appendChild(root);

    lb = {
      root: root, list: list, index: start, opener: document.activeElement,
      img: root.querySelector('.torque-lightbox__img'),
      count: root.querySelector('.torque-lightbox__count'),
      prevOverflow: document.body.style.overflow,
      onKey: function (e) {
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') showSlide(lb.index - 1);
        else if (e.key === 'ArrowRight') showSlide(lb.index + 1);
      }
    };
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', lb.onKey);

    var single = list.length < 2;
    root.querySelectorAll('.torque-lightbox__nav').forEach(function (b) { b.hidden = single; });
    root.querySelector('.torque-lightbox__count').hidden = single;

    root.querySelector('.torque-lightbox__close').addEventListener('click', closeLightbox);
    root.querySelector('.torque-lightbox__nav--prev').addEventListener('click', function () { showSlide(lb.index - 1); });
    root.querySelector('.torque-lightbox__nav--next').addEventListener('click', function () { showSlide(lb.index + 1); });
    // Tap on the dark background closes; tapping the image itself does not.
    root.addEventListener('click', function (e) { if (e.target === root) closeLightbox(); });

    // Swipe left / right between images (single-finger only, so pinch-zoom still works).
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null || single) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 50) showSlide(lb.index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    showSlide(start);
    root.querySelector('.torque-lightbox__close').focus();
  }

  // Capture phase: runs before the theme's own click handler (which cancels the click).
  document.addEventListener('click', function (evt) {
    if (lb || !touchMq || !touchMq.matches) return;
    var item = evt.target.closest && evt.target.closest('media-gallery .media-viewer__item');
    if (!item || item.querySelector('deferred-media, product-model')) return;
    if (!evt.target.closest('.media')) return;
    var gallery = item.closest('media-gallery');
    if (!gallery || !galleryImages(gallery).length) return;
    evt.preventDefault();
    evt.stopPropagation();
    openLightbox(gallery, item);
  }, true);

  /* ---------- Fitment message: vehicle name in regular weight ---------- */
  // The fitment block writes "Fits your <vehicle>" / "Fit not verified for your <vehicle>" as one
  // plain string. Wrap the vehicle part so it can be styled separately (see .fyc-vehicle in the CSS).
  var FITMENT_RE = /^(Fits your |Fit not verified for your )(.+)$/;

  function splitFitmentText(el) {
    var match = FITMENT_RE.exec(el.textContent);
    if (!match || el.querySelector('.fyc-vehicle')) return;
    var name = document.createElement('span');
    name.className = 'fyc-vehicle';
    name.textContent = match[2];
    el.textContent = match[1];
    el.appendChild(name);
  }

  function watchFitment() {
    document.querySelectorAll('[data-fyc-fit-vehicle], [data-fyc-unverified-vehicle]').forEach(function (el) {
      if (el.dataset.torqueWatched) return;
      el.dataset.torqueWatched = '1';
      splitFitmentText(el);
      new MutationObserver(function () { splitFitmentText(el); }).observe(el, { childList: true });
    });
  }

  if (document.readyState !== 'loading') watchFitment();
  else document.addEventListener('DOMContentLoaded', watchFitment);
  document.addEventListener('shopify:section:load', watchFitment);

  /* ---------- Mobile: tap the star rating beside the price to jump to the reviews ---------- */
  var mqRatings = window.matchMedia('(max-width: 768px)');

  function reviewsTarget() {
    return document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-review-widget, [id*="judge_me_reviews_review_widget"]');
  }

  // The header sticks to the top of the screen, so leave room for it above the reviews.
  // Measures whichever header-group section is currently pinned to the top.
  function headerOffset() {
    var offset = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (section) {
      var position = getComputedStyle(section).position;
      if (position !== 'sticky' && position !== 'fixed') return;
      var rect = section.getBoundingClientRect();
      if (rect.top <= 1 && rect.bottom > offset) offset = rect.bottom;
    });
    return offset;
  }

  function scrollToReviews(e) {
    var rating = e.target.closest && e.target.closest('.product-info__price .custom-pdp-rating-wrapper');
    if (!rating || rating.closest('.sticky-buybar') || !mqRatings.matches) return;
    var target = reviewsTarget();
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', scrollToReviews);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var el = e.target;
      if (el && el.classList && el.classList.contains('custom-pdp-rating-wrapper')) scrollToReviews(e);
    }
  });

  function prepRatings() {
    document.querySelectorAll('.product-info__price .custom-pdp-rating-wrapper').forEach(function (el) {
      if (el.dataset.torqueRatingLink) return;
      el.dataset.torqueRatingLink = '1';
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Read customer reviews');
    });
  }

  if (document.readyState !== 'loading') prepRatings();
  else document.addEventListener('DOMContentLoaded', prepRatings);
  document.addEventListener('shopify:section:load', prepRatings);
}());
